<template>
	<div>
		<!--v-if="authority[item.authority]"-->
		<el-button v-if="pan(item)" @click="click(item.val,item)" v-for="(item,key) in buttons" :key="key" :size="size">{{item.txt}}</el-button>
		<tanEditComAddress @edit="tanEdit" :authority="authority" :tanData="tanComAddressData" v-if='tanComAddressShow'
		 :ishow.sync="tanComAddressShow"></tanEditComAddress>
	</div>
</template>

<script>
	import {
		DeleteBusinessLicense,
		EditCertificateFileCabinet
	} from '@/js/urls'
	import {
		EditTenderBidding_state
	} from '@/js/urls_sxm'
	import tanEditComAddress from '@/components/tan/tanEditComAddress'
	export default {
		components: {
			tanEditComAddress
		},
		data() {
			return {
				size: 'mini',
				tanComAddressShow: false,
				tanComAddressData: {},
				buttons: [{
					txt: '查看',
					val: 'detail',
					authority: 'show_authority'
				}, {
					txt: '编辑',
					val: 'edit',
					authority: 'edit_authority'
				}, {
					txt: '中标审核',
					val: 'sure',
					authority: 'edit_authority',
					tag: 'sure',
					isZB: true
				}, {
					txt: '报名确认',
					val: 'comfire',
					authority: 'edit_authority',
					tag: 'sure',
					isBM: true
				}, {
					txt: '删除',
					val: 'del',
					authority: 'delete_authority'
				}],

				mapping: {
					BusinessLicense: {
						menu_id: 33,
						name: '营业执照',
						url: 'companyCertificateDetail'
					},
					QualificationsCertificate: {
						menu_id: 34,
						name: '资质证书',
						url: 'companyCertificateDetail'
					},
					SafetyProductionLicense: {
						menu_id: 50,
						name: '安全许可证',
						url: 'companyCertificateDetail'
					},
					BankAccount: {
						menu_id: 51,
						name: '银行账户',
						url: 'companyCertificateDetail'
					},
					ComCustomizeCertificate: {
						menu_id: 121,
						name: '自定义企业证书',
						url: 'companyCertificateDetail'
					},
					PersonCertificateBase: (type) => {
						let menu_id = 0
						switch (type) {
							case '注册类人员':
								menu_id = 40
								name = '注册类人员'
								break;
							case '技术职称人员':
								menu_id = 41
								name = '技术职称人员'
								break;
							case '现场管理人员':
								menu_id = 46
								name = '现场管理人员'
								break;
							case '技术工人':
								menu_id = 47
								name = '技术工人'
								break;
							case '安全三类人员':
								menu_id = 48
								name = '安全三类人员'
								break;
							case '特种作业人员':
								menu_id = 49
								name = '特种作业人员'
								break;
							case '自定义人员证书':
								menu_id = 120
								name = '自定义人员证书'
								break;
						}
						return {
							menu_id,
							name,
							url: 'personCertificateDetail'
						}

					},
					TechnicalTitleAttribute: {
						menu_id: 41,
						url: 'personCertificateDetail'
					},
					SiteManageAttribute: {
						menu_id: 46,
						url: 'personCertificateDetail'
					},
					TechnologyWorkerAttribute: {
						menu_id: 47,
						url: 'personCertificateDetail'
					},
					SafetyThreeTypeAttribute: {
						menu_id: 48,
						url: 'personCertificateDetail'
					},
					SpecialtyOperationAttribute: {
						menu_id: 49,
						url: 'personCertificateDetail'
					},
					PersonCustomizeCertificate: {
						menu_id: 120,
						url: 'personCertificateDetail'
					},
					DigitalCertificate: (type) => {
						let menu_id = 0
						if (type == 1337) { //企业
							menu_id = 61
						}
						if (type == 1338) { //网银
							menu_id = 79
						}
						if (type == 1336) { //个人
							menu_id = 62
						}
						return {
							menu_id,
							url: 'digitalCertificateDetail'
						}
					},
				}
			}
		},

		created() {
			this.tanComAddressData = this.row
		},
		watch: {
			row() {
				this.tanComAddressData = this.row
			}
		},
		props: {
			row: {
				type: Object,
				default: () => ({})
			},
			authority: {
				type: Object,
				default: () => ({})
			},
			type: "",
			childrenCom: ''
		},
		methods: {
			bidReview() {

			},
			confirm() {

			},
			click(val, item) {
				console.log(val);
				switch (val) {
					case 'detail':
						//文件夹文件的查看
						if (this.$route.name == 'seeCabinet') {
							this.toSeePage('详情')
						} else {
							this.toPage(val, '详情')
						}
						break;
					case 'edit':
						if (this.$route.name == 'ComAddressBook') {
							//企业通讯录
							this.tanComAddressShow = true
						} else if (this.$route.name == 'MandCabinet' || this.$route.name == 'CertificateFileCabinet') {
							console.log(2222222);
							//证书文件柜管理
							this.fixCabient()
						} else {
							this.toPage(val, '编辑', 0)
						}
						break;
					case 'del':
						switch (this.$route.name) {
							// 企业证书
							case 'companyCertificate':
								if (this.row.certificate_goes != '在册' && this.row.certificate_goes != undefined) {
									this.$message.error('证书无法删除');
								} else {
									this.del(val)
								}
								break;
								// 人员证书
							case 'personCertificate':
								if (this.row.certificate_goes != '在册' || this.row.certificate_state != '空闲' && this.row.certificate_goes !=
									undefined && this.row.certificate_state != undefined) {
									this.$message.error('人员证书无法删除');
								} else {
									this.del(val)
								}
								break;
								// 文件夹
							case 'CertificateFileCabinet':
								if (this.row.certificate_File_num != 0 && this.row.certificate_File_num != undefined) {
									this.$message.error('文件夹无法删除');
								} else {
									this.del(val)
								}
								break;
								// 文件柜
//							case 'MandCabinet':
//								if (this.row.File_num != 0 && this.row.File_num != undefined) {
//									this.$message.error('文件柜无法删除');
//								} else {
//									this.del(val)
//								}
//								break;
								// 人员
//							case 'IncumbentEmployee':
//								if (this.row.certificate_num != '0' && this.row.certificate_num != undefined) {
//									this.$message.error('人员有证书无法删除');
//								} else {
//									this.del(val)
//								}
//								break;
								// 数字证书
							case 'digitalCertificate':
								if (this.row.certificate_goes != '在册' && this.row.certificate_goes != undefined) {
									this.$message.error('数字证书无法删除');
								} else {
									this.del(val)
								}
								break;
							default:
								this.del(val)
								break;
						}
						break;
					case 'sure':
						this.sure_shenhe()
						break;
					case 'comfire':
						this.sure_baoming()
						break;
				}
			},
			del(val) {
				let flag = false;
				if(this.$route.path=='/IncumbentEmployee'){
					flag=true
				}
				this.iConfirm('提示', flag==true?'请确认该信息下是否有账号，删除后，账号不能登录':'你确定删除吗？', () => {
					let delPromise = this.$route.meta.delPromise
					if (this.$route.name == 'seeCabinet') {
						this.httpBack(delPromise({
							primary_key: this.row[this.$route.meta.key],
							value: this.row.tablename
						}), (res) => {
							this.$message.success('删除成功')
							this.$emit('click', val)
						})
					} else {
						this.httpBack(delPromise({
							primary_key: this.row[this.$route.meta.key],
						}), (res) => {
							this.$message.success('删除成功')
							this.$emit('click', val)
						})
					}

				});
			},
			sure_shenhe() {
				this.$confirm('投标状态审核', '审核选择', {
					distinguishCancelAndClose: true,
					confirmButtonText: '已中标',
					cancelButtonText: '未中标'
				}).then(() => {
					this.$confirm('您选择的是已中标', '审核选择', {
						confirmButtonText: '确定',
						cancelButtonText: '取消'
					}).then(() => {
						this.httpBack(EditTenderBidding_state({
							project_tender_id: this.row.project_tender_id,
							bidding_state: 1358
						}), (res) => {
							this.$message({
								message: '请到投标详情中补充中标详情',
								type: 'success'
							})
							setTimeout(() => {
								this.$parent.$parent.$parent.getinfo()
							}, 1000)
						})
					})
				}).catch(action => {
					if(action === 'close'){
						this.$message({
							message: '已取消',
							type: 'error'
						})
					}else{
						this.$confirm('您选择的是未中标', '审核选择', {
							confirmButtonText: '确定',
							cancelButtonText: '取消'
						}).then(() => {
							this.httpBack(EditTenderBidding_state({
								project_tender_id: this.row.project_tender_id,
								bidding_state: 1357
							}), (res) => {
								this.$message({
									message: '成功修改为未中标',
									type: 'success'
								})
								setTimeout(() => {
									this.$parent.$parent.$parent.getinfo()
								}, 1000)
							})
						})
					}
				});
			},
			sure_baoming() {
				//询问框
				this.$confirm('是否确认报名', '确认报名', {
					confirmButtonText: '确认报名',
					cancelButtonText: '取消报名'
				}).then(() => {
					this.httpBack(EditTenderBidding_state({
						project_tender_id: this.row.project_tender_id,
						bidding_state: 1356
					}), (res) => {
						this.$message({
							message: '报名成功',
							type: 'success'
						})
						setTimeout(() => {
							this.$parent.$parent.$parent.getinfo()
						}, 1000)

					})
				});
			},
			toSeePage(title) {
				let obj = undefined
				console.log(this.row.base_table_name)
				if (this.row.base_table_name == 'DigitalCertificate') {
					obj = this.mapping[this.row.base_table_name](this.row['certificate_type_id'])
				} else if (this.row.base_table_name == 'PersonCertificateBase') {
					obj = this.mapping[this.row.base_table_name](this.row['certificate_lx'])
				} else {
					obj = this.mapping[this.row.base_table_name]
					console.log(this.mapping[this.row.base_table_name])
				}
				obj.title = title
				obj.primary_key = this.row.base_table_id
				console.log(obj)
				this.openNewTab(obj, obj)
			},
			toPage(type, title, state, tag) {
				let name = ''
				if (this.$route.path == '/digitalCertificate') {
					name = this.row.certificate_type_id
				}
				if (this.$route.path == '/companyCertificate') {
					name = this.row.certificate_type_id
				}
				if (this.$route.path == '/personCertificate') {
					name = this.row.certificate_type_id
				}
				this.openNewTab({
					url: this.$route.meta[type].name,
					menu_id: this.$route.meta.child_menu_id,
					title: title,
				}, {
					state: state, //0代表编辑，1代表添加,编辑添加页面有效
					primary_key: this.row[this.$route.meta.key],
					menu_id: this.$route.meta.child_menu_id,
					name: name,
					authority: this.authority,
					type: this.type,
					childrenCom: this.childrenCom
				}, tag)
			},
			pan(item) {
				if ('tag' in item) {
					if (this.row.audit_state == '审核通过') {
						if (!this.row.bidding_state || this.row.bidding_state_id == 1355) {
							return this.authority[item.authority] && item.isBM
						} else if (this.row.bidding_state_id == 1356) {
							return this.authority[item.authority] && item.isZB
						}
					}
				} else if (this.$route.path == '/seeCabinet') {
					if (!this.row.show_authority) {
						if (item.txt == '查看' || item.txt == '编辑') {
							return false
						} else {
							return this.authority[item.authority] || this.row[item.authority]
						}
					} else {
						if (item.txt == '编辑') {
							return false
						} else {
							return this.authority[item.authority] || this.row[item.authority]
						}
					}

				} else if (this.$route.path == '/MandCabinet') {
					if (item.txt == '查看') {
						return false
					} else {
						return this.authority[item.authority] || this.row[item.authority]
					}
				} else if (this.$route.path == '/ResignationEmployee') {
					if (item.txt == '编辑') {
						return false
					} else {
						return this.authority[item.authority] || this.row[item.authority]
					}
				}else {
					return this.authority[item.authority] || this.row[item.authority]
				}

			},
			fixCabient() {
				//修改证书文件柜及文件夹
				this.iPrompt('修改提示', '输入要修改的名称', (val) => {
					if (val == null) {
						this.$message.error('请输入名称');
					} else if (val.length > 20) {
						this.$message.error('名称过长');
					} else {
						val = val.replace(/\s+/g, '')
						if (val == '') {
							this.$message.error('名称不能为空格');
						} else {
							this.httpBack(EditCertificateFileCabinet({
								file_cabinet_id: this.row[this.$route.meta.key],
								file_cabinet_name: val
							}), (res) => {
								this.$message.success('修改成功')
								this.$emit('shuaXin')
							}, (res) => {
								this.$message.error('名称重复')
							})
						}
					}

				})
			},
			tanEdit() {
				this.$emit('shuaXin')
			}
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/sub/listCaoZuo.vue